define("checkout/components/input-stepper", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class={{concat-classes "o--btnGroup" (if @didAutoAdd "tCK--stepper tCK--stepper--hl")}}
    data-test-id="input-stepper"
  >
    <Shared::Ui::Button
      @isDisabled={{this.isStepDownDisabled}}
      @onClick={{@onStepDown}}
      @variant="outline"
      class="tCH--text--highlight qa--{{@id}}StepperDownBtn"
      data-test-id="input-stepper-down-button"
    >
      {{svg-jar "minus" class="o--icon--sm qa--minus_circle"}}
    </Shared::Ui::Button>
    {{#if (and this.isStepDownDisabled @tooltipAtMin)}}
      <EmberTooltip @delay={{330}} @side="top" data-test-id="input-stepper-down-tooltip">
        {{@tooltipAtMin}}
      </EmberTooltip>
    {{/if}}
    <Shared::Ui::Button
      @variant="outline"
      class="u--text--black qa--{{@id}}StepperValue"
      data-test-addon-id={{@testId}}
      data-test-id="input-stepper-value"
      data-test-value={{@currentValue}}
    >
      {{@currentValue}}
    </Shared::Ui::Button>
    <Shared::Ui::Button
      @isDisabled={{this.isSeamlessCheckoutInProgress}}
      @onClick={{@onStepUp}}
      @variant="outline"
      class="tCH--text--highlight qa--{{@id}}StepperUpBtn"
      data-test-id="input-stepper-up-button"
    >
      {{svg-jar "add" class="o--icon--sm qa--minus_circle"}}
    </Shared::Ui::Button>
  
  </div>
  */
  {
    "id": "wICHbbDg",
    "block": "[[[10,0],[15,0,[28,[37,0],[\"o--btnGroup\",[52,[30,1],\"tCK--stepper tCK--stepper--hl\"]],null]],[14,\"data-test-id\",\"input-stepper\"],[12],[1,\"\\n  \"],[8,[39,2],[[16,0,[29,[\"tCH--text--highlight qa--\",[30,2],\"StepperDownBtn\"]]],[24,\"data-test-id\",\"input-stepper-down-button\"]],[[\"@isDisabled\",\"@onClick\",\"@variant\"],[[30,0,[\"isStepDownDisabled\"]],[30,3],\"outline\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,3],[\"minus\"],[[\"class\"],[\"o--icon--sm qa--minus_circle\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[41,[28,[37,4],[[30,0,[\"isStepDownDisabled\"]],[30,4]],null],[[[1,\"    \"],[8,[39,5],[[24,\"data-test-id\",\"input-stepper-down-tooltip\"]],[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[30,4]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[8,[39,2],[[16,0,[29,[\"u--text--black qa--\",[30,2],\"StepperValue\"]]],[16,\"data-test-addon-id\",[30,5]],[24,\"data-test-id\",\"input-stepper-value\"],[16,\"data-test-value\",[30,6]]],[[\"@variant\"],[\"outline\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[30,6]],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[8,[39,2],[[16,0,[29,[\"tCH--text--highlight qa--\",[30,2],\"StepperUpBtn\"]]],[24,\"data-test-id\",\"input-stepper-up-button\"]],[[\"@isDisabled\",\"@onClick\",\"@variant\"],[[30,0,[\"isSeamlessCheckoutInProgress\"]],[30,7],\"outline\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,3],[\"add\"],[[\"class\"],[\"o--icon--sm qa--minus_circle\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[13]],[\"@didAutoAdd\",\"@id\",\"@onStepDown\",\"@tooltipAtMin\",\"@testId\",\"@currentValue\",\"@onStepUp\"],false,[\"concat-classes\",\"if\",\"shared/ui/button\",\"svg-jar\",\"and\",\"ember-tooltip\"]]",
    "moduleName": "checkout/components/input-stepper.hbs",
    "isStrictMode": false
  });
  let InputStepperComponent = _exports.default = (_class = class InputStepperComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor, this);
    }
    get isStepDownDisabled() {
      return this.args.currentValue <= (this.args.minValue || 0) || this.isSeamlessCheckoutInProgress;
    }
    get isSeamlessCheckoutInProgress() {
      return this.seamlessCheckoutManager.isCheckoutInProgress;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, InputStepperComponent);
});